import BlankNotice from '@components/blank/BlankNotice';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import useNotices from './hooks/useNotices';
import NoticeItem from './NoticeItem';

function NoticeList() {
    const {
        notices, fetchNextPage, isBlank, isFetching,
    } = useNotices();
    return (
        <Container as='main' fullWidth spacing={18}
            align='center' >
            {isBlank && (
                <BlankNotice/>
            )}
            {notices?.map((notice) => (
                <NoticeItem notice={notice}
                    key={notice.id} />
            ))}
            {isFetching && (
                <Loading size='small' />
            )}
            <InfinityScrollTrigger trigger={fetchNextPage}/>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px;
`;

export default NoticeList;
